const defaultLocalExercises = {
  d1: {
    id: "d1",
    name: "Pushups",
    description: "",
    equipment: {
      weights: false,
      balanceBoard: false,
      band: false,
      medicineBall: false,
      gymnasticBall: false,
      pullupBar: false,
    },
    time: -1,
    reps: 12,
    image: require("../../images/defaultExercises/pushups.jpg"),
    moreInfo: "",
    dropSets: false,
    dropSetInfo: {},
  },
  d2: {
    id: "d2",
    name: "Pullups",
    description: "",
    equipment: {
      weights: false,
      balanceBoard: false,
      band: false,
      medicineBall: false,
      gymnasticBall: false,
      pullupBar: true,
    },
    time: -1,
    reps: 12,
    image: require("../../images/defaultExercises/pullups.jpg"),
    moreInfo: "",
    dropSets: false,
    dropSetInfo: {},
  },
  d3: {
    id: "d3",
    name: "Lunges",
    description: "",
    equipment: {
      weights: false,
      balanceBoard: false,
      band: false,
      medicineBall: false,
      gymnasticBall: false,
      pullupBar: false,
    },
    time: -1,
    reps: 12,
    image: require("../../images/defaultExercises/lunges.jpg"),
    moreInfo: "",
    dropSets: false,
    dropSetInfo: {},
  },
  d4: {
    id: "d4",
    name: "Plank",
    description: "",
    equipment: {
      weights: false,
      balanceBoard: false,
      band: false,
      medicineBall: false,
      gymnasticBall: false,
      pullupBar: false,
    },
    time: 60,
    reps: -1,
    image: require("../../images/defaultExercises/plank.jpg"),
    moreInfo: "",
    dropSets: false,
    dropSetInfo: {},
  },
  d5: {
    id: "d5",
    name: "Bench Press",
    description: "",
    equipment: {
      weights: true,
      balanceBoard: false,
      band: false,
      medicineBall: false,
      gymnasticBall: false,
      pullupBar: false,
    },
    time: -1,
    reps: 12,
    image: require("../../images/defaultExercises/bench-press.jpg"),
    moreInfo: "",
    dropSets: false,
    dropSetInfo: {},
  },
  d6: {
    id: "d6",
    name: "Side Plank",
    description: "",
    equipment: {
      weights: false,
      balanceBoard: false,
      band: false,
      medicineBall: false,
      gymnasticBall: false,
      pullupBar: false,
    },
    time: 60,
    reps: -1,
    image: require("../../images/defaultExercises/side-plank.jpg"),
    moreInfo: "",
    dropSets: false,
    dropSetInfo: {},
  },
  d7: {
    id: "d7",
    name: "Crunches",
    description: "",
    equipment: {
      weights: false,
      balanceBoard: false,
      band: false,
      medicineBall: false,
      gymnasticBall: false,
      pullupBar: false,
    },
    time: -1,
    reps: 12,
    image: require("../../images/defaultExercises/crunches.jpg"),
    moreInfo: "",
    dropSets: false,
    dropSetInfo: {},
  },
  d8: {
    id: "d8",
    name: "Squat",
    description: "",
    equipment: {
      weights: false,
      balanceBoard: false,
      band: false,
      medicineBall: false,
      gymnasticBall: false,
      pullupBar: true,
    },
    time: -1,
    reps: 12,
    image: require("../../images/defaultExercises/squat.jpg"),
    moreInfo: "",
    dropSets: false,
    dropSetInfo: {},
  },
  d9: {
    id: "d9",
    name: "Skipping Rope",
    description: "",
    equipment: {
      weights: false,
      balanceBoard: false,
      band: false,
      medicineBall: false,
      gymnasticBall: false,
      pullupBar: false,
    },
    time: 120,
    reps: -1,
    image: require("../../images/defaultExercises/skipping-rope.jpg"),
    moreInfo: "",
    dropSets: false,
    dropSetInfo: {},
  },
  d10: {
    id: "d10",
    name: "Balance Board",
    description: "",
    equipment: {
      weights: false,
      balanceBoard: false,
      band: false,
      medicineBall: false,
      gymnasticBall: false,
      pullupBar: false,
    },
    time: 180,
    reps: -1,
    image: require("../../images/defaultExercises/balance-board.jpg"),
    moreInfo: "",
    dropSets: false,
    dropSetInfo: {},
  },
  d11: {
    id: "d11",
    name: "Medicine Ball Throw",
    description: "",
    equipment: {
      weights: false,
      balanceBoard: false,
      band: false,
      medicineBall: true,
      gymnasticBall: false,
      pullupBar: false,
    },
    time: -1,
    reps: 20,
    image: require("../../images/defaultExercises/medicine-ball-throw.jpg"),
    moreInfo: "",
    dropSets: false,
    dropSetInfo: {},
  },
  d12: {
    id: "d12",
    name: "Biceps Curls",
    description: "",
    equipment: {
      weights: true,
      balanceBoard: false,
      band: false,
      medicineBall: false,
      gymnasticBall: false,
      pullupBar: false,
    },
    time: -1,
    reps: 20,
    image: require("../../images/defaultExercises/biceps-curls.jpg"),
    moreInfo: "",
    dropSets: false,
    dropSetInfo: {},
  },
  d13: {
    id: "d13",
    name: "Shoulder Press",
    description: "",
    equipment: {
      weights: true,
      balanceBoard: false,
      band: false,
      medicineBall: false,
      gymnasticBall: false,
      pullupBar: false,
    },
    time: -1,
    reps: 10,
    image: require("../../images/defaultExercises/shoulder-press.jpg"),
    moreInfo: "",
    dropSets: false,
    dropSetInfo: {},
  },
  d14: {
    id: "d14",
    name: "Jogging",
    description: "",
    equipment: {
      weights: false,
      balanceBoard: false,
      band: false,
      medicineBall: false,
      gymnasticBall: false,
      pullupBar: false,
    },
    time: 1800,
    reps: -1,
    image: require("../../images/defaultExercises/jogging.jpg"),
    moreInfo: "",
    dropSets: false,
    dropSetInfo: {},
  },
  d15: {
    id: "d15",
    name: "Sprints",
    description: "",
    equipment: {
      weights: false,
      balanceBoard: false,
      band: false,
      medicineBall: false,
      gymnasticBall: false,
      pullupBar: false,
    },
    time: -1,
    reps: 10,
    image: require("../../images/defaultExercises/sprints.jpg"),
    moreInfo: "",
    dropSets: false,
    dropSetInfo: {},
  },
  d16: {
    id: "d16",
    name: "Stretching",
    description: "",
    equipment: {
      weights: false,
      balanceBoard: false,
      band: false,
      medicineBall: false,
      gymnasticBall: false,
      pullupBar: false,
    },
    time: 900,
    reps: -1,
    image: require("../../images/defaultExercises/stretching.jpg"),
    moreInfo: "",
    dropSets: false,
    dropSetInfo: {},
  },
};

export default defaultLocalExercises;
